export default __webpack_public_path__ + "static/media/call-icon.0cdfc81b.svg";